import React from 'react';
import './Privacidade.css';

/**
 * Página de Política de Privacidade
 * Necessária para verificação OAuth2 do Google Workspace
 */
const Privacidade = () => {
  return (
    <div className="privacidade-container">
      <div className="privacidade-content">
        <h1>Política de Privacidade - NerdzPoker</h1>
        
        <section>
          <h2>1. Informações que Coletamos</h2>
          <p>
            Ao utilizar o login do Google no NerdzPoker, coletamos apenas as informações básicas 
            fornecidas pela Google Auth Platform: seu nome, endereço de e-mail e foto do perfil.
          </p>
        </section>

        <section>
          <h2>2. Como Usamos seus Dados</h2>
          <p>Seus dados são utilizados exclusivamente para:</p>
          <ul>
            <li>Identificar você nas mesas de jogo e rankings.</li>
            <li>Facilitar o acesso administrativo ao sistema de housegame.</li>
          </ul>
          <p>
            Não compartilhamos seus dados com terceiros nem os utilizamos para fins de marketing.
          </p>
        </section>

        <section>
          <h2>3. Armazenamento e Segurança</h2>
          <p>
            Os dados são armazenados de forma segura e utilizados apenas enquanto você for um 
            membro ativo do nosso grupo de poker.
          </p>
        </section>

        <section>
          <h2>4. Seus Direitos</h2>
          <p>
            Você pode solicitar a exclusão dos seus dados a qualquer momento entrando em contato 
            com o administrador pelo e-mail.
          </p>
        </section>
        
        <footer className="app-footer">
          <div className="footer-content">
            <p className="footer-signature">
              Produzido by <strong>Chicão</strong>
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Privacidade;
